// Change the view of the product cart
const sortGallery = document.getElementById('sort-gallery-product');
const sortGrid = document.getElementById('sort-grid-product');
const productGrid = document.getElementsByClassName('product__media-list contains-media grid grid--peek list-unstyled slider slider--mobile');
const listGrid = document.getElementsByClassName('product__media-item grid__item slider__slide');
const dotsList = document.querySelector('.slider-counter')

const toggleClasses = function() {
    productGrid[0].classList.toggle('flex-wrap');
    productGrid[0].classList.toggle('p-05');
    sortGallery.classList.toggle('active');
    sortGrid.classList.toggle('active');
    dotsList.classList.toggle('visibiliti-hidden');
    for (let item of listGrid) {
     item.classList.toggle('product-li');
    }
}

sortGrid.addEventListener('click', () => { 
  if (sortGrid.classList.contains('active')) {
    console.log('Sorting like gallery already chosen');
  } else {
    toggleClasses();
  }
});

sortGallery.addEventListener('click', () => { 
  if (sortGallery.classList.contains('active')) {
    console.log('Sorting like gallery already chosen');
  } else {
   toggleClasses();
  }
});